import { Outlet } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import NoiseOverlay from "@/components/site/NoiseOverlay";
import ScrollToTop from "@/components/site/ScrollToTop";

export default function Layout() {
  return (
    <div className="relative min-h-screen bg-white">
      <NoiseOverlay />
      <ScrollToTop />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
